import client from "graphql/client";
import { loader } from "graphql.macro";
import {
    VIDEODESCRIPTIONS_SET,
    VIDEODESCRIPTIONS_SET_LOADING
} from "../types";

const fetchVideoDescriptionsQuery = loader("../../graphql/queries/videoDescriptions.graphql");

export const fetchVideoDescriptionsAction = () => async (dispatch) => {
    dispatch({ type: VIDEODESCRIPTIONS_SET_LOADING, loading: true });

    try {
        const response = await client.query({
            query: fetchVideoDescriptionsQuery,
            fetchPolicy: "network-only"
        });
        dispatch({
            type: VIDEODESCRIPTIONS_SET,
            videoDescriptions: response?.data?.adminVideoDescriptions || [],
        });
    } catch (error) {
        console.error("Error fetching video descriptions:", error);
    } finally {
        dispatch({ type: VIDEODESCRIPTIONS_SET_LOADING, loading: false });
    }
};
